import { 
    TbWorld, 
    TbBrandInstagram, 
    TbBrandFacebook,
    TbBrandTwitter,
    TbBrandTiktok,
    TbBrandYoutube,
    TbBrandLinkedin,
    TbBrandWhatsapp
} from 'react-icons/tb';
import React from 'react';

export const LINK_SUBTYPES = [
    { value: 'website',   label: 'Website',   icon: <TbWorld />,           color: '#374151' },
    { value: 'instagram', label: 'Instagram', icon: <TbBrandInstagram />,   color: '#E1306C' },
    { value: 'facebook',  label: 'Facebook',  icon: <TbBrandFacebook />,    color: '#1877F2' },
    { value: 'twitter',   label: 'Twitter',   icon: <TbBrandTwitter />,     color: '#1DA1F2' },
    { value: 'tiktok',    label: 'TikTok',    icon: <TbBrandTiktok />,      color: '#000000' },
    { value: 'youtube',   label: 'YouTube',   icon: <TbBrandYoutube />,     color: '#FF0000' },
    { value: 'linkedin',  label: 'LinkedIn',  icon: <TbBrandLinkedin />,    color: '#0A66C2' },
    { value: 'whatsapp',  label: 'WhatsApp',  icon: <TbBrandWhatsapp />,    color: '#25D366' },
    { value: 'other',     label: 'Other Link',icon: <TbWorld />,            color: '#6b7280' },
];

export const getLinkSubtype = (value) =>
    LINK_SUBTYPES.find(s => s.value === value) || LINK_SUBTYPES[0];

export const getLinkIcon = (subtype, size = '1.2rem') => {
    const config = getLinkSubtype(subtype);
    return React.cloneElement(config.icon, { 
        size, 
        color: config.color,
        title: config.label
    });
};